import _ from 'lodash';
import createCachedSelector from 're-reselect';
import { getPredictor } from '../getPredictor';

export const getOutputs = createCachedSelector(
  [getPredictor],
  predictor => _.chain(predictor).get('outputMappings').map('output').value()
)(
  (state, chartType) => chartType
);